import { apiInstanceWithToken } from "../integrations/ApiInstance";
import "react-toastify/dist/ReactToastify.css";
import {
  expenseEndpoints
} from "../integrations/ApiEndpoints";

import { showErrorToast } from "../utils/Toasts";

export const createExpense = async (data) => {
  try {
    const response = await apiInstanceWithToken.post(expenseEndpoints.createExpense, data);
    console.log(response.data.success);
    if (response?.status === 201) {
      return response.data.success;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவேற்றத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};

export const viewExpense = async (data) => {
  try {
    const response = await apiInstanceWithToken.get(expenseEndpoints.viewExpense, { params: data });
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவேற்றத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};

export const approveExpense = async (data) => {
  try {
    const response = await apiInstanceWithToken.post(expenseEndpoints.approveExpense, data);
    if (response?.status === 200) {
      return response.data.success;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவேற்றத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};

export const markPaidExpense = async (data) => {
  try {
    const response = await apiInstanceWithToken.post(expenseEndpoints.markPaidExpense, data);
    if (response?.status === 200) {
      return response.data.success;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவேற்றத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};